import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useAuth } from "./hooks/useAuth";

const ProtectedRoute = ({ children, requiredRoles = null }) => {
  const { user, userProfile, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  // Mostrar carga solo al verificar autenticación
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          gap: 2,
          backgroundColor: "#f5f5f5",
        }}
      >
        <Box
          sx={{
            width: 60,
            height: 60,
            borderRadius: 3,
            backgroundColor: "#1976d2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 1,
          }}
        >
          <Typography
            sx={{ color: "white", fontWeight: 800, fontSize: "1.5rem" }}
          >
            P
          </Typography>
        </Box>
        <CircularProgress size={28} />
        <Typography variant="body2" color="text.secondary">
          Cargando...
        </Typography>
      </Box>
    );
  }

  // No autenticado → Login
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // Verificar roles si es necesario
  if (
    requiredRoles &&
    userProfile &&
    !requiredRoles.includes(userProfile.role)
  ) {
    return <Navigate to="/" replace />;
  }

  // Todo OK
  return children;
};

export const GuestRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return null;

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
